<template>
  <div class="App"></div>
</template>

<script>
import gmapsInit from "@/utils/gmaps";
import moment from "moment";

export default {
  name: "App",
  data() {
    return {
      polygonCoords: [],
      index: null,
      map: null,
      infowindow: null,
      infowindows: [],
      marker: null,
      markers: [],
      circle: null,
      circles: [],
      lat: 0,
      lng: 0,
      terminalID: "",
      images: {
        sample: require("./../assets/map_pin.png")
      }
    };
  },
  props: {
    center: {
      type: Object
    },
    zoom: {
      type: Number
    }
  },
  computed: {
    returnData() {
      return {
        id: this.terminalID,
        coordinates: this.polygonCoords
      };
    },
    previewPolygonCoords() {
      return {
        coordinates: this.polygonCoords
      };
    }
  },
  methods: {
    async initializeMap() {
      try {
        let pm = this;

        const google = await gmapsInit();
        pm.map = new google.maps.Map(this.$el, {
          center: this.center,
          zoom: this.zoom
        });

        google.maps.event.addListener(pm.map, "drag", function() {
          const center = pm.map.getCenter();
          if (pm.marker) pm.marker.setPosition(center);
          if (pm.circle) pm.circle.setCenter(center);

          pm.$emit("currentCenter", {
            lat: center.lat(),
            lng: center.lng()
          });
        });
      } catch (error) {
        console.error(error);
      }
    },
    async plotPosts(data) {
      this.marker = null;
      this.markers = [];
      this.circle = null;
      this.circles = [];

      const google = await gmapsInit();

      let bounds = new google.maps.LatLngBounds();

      await Promise.all(
        data.map(item => {
          const { name, post, plot, lat, lng, radius } = item;

          let myLatLng = new google.maps.LatLng(lat, lng);

          const marker = new google.maps.Marker({
            position: myLatLng,
            map: this.map,
            visible: plot
          });

          const circle = new google.maps.Circle({
            strokeWeight: 0,
            fillColor: "#008000",
            fillOpacity: 0.35,
            map: this.map,
            center: {
              lat: lat,
              lng: lng
            },
            radius: radius,
            visible: plot
          });

          const infowindow = new google.maps.InfoWindow({
            content: ` name: ${name}<br>
                       post: ${post}<br>`
          });

          if (plot) {
            infowindow.open(this.map, marker);
          }

          this.markers.push(marker);
          this.circles.push(circle);
          this.infowindows.push(infowindow);

          bounds.extend(myLatLng);
        })
      );

      const center = bounds.getCenter();

      // this.map.fitBounds(bounds);

      const zoom = this.map.getZoom();

      this.map.setCenter(center);

      this.map.setZoom(12); // Why 17? Because it looks good.
      // }
    },
    async setPost(data) {
      // console.log(data);
      const { id, index, plot, lat, lng, radius } = data;

      this.index = index;
      // const google = await gmapsInit();

      let pm = this;

      let map = this.map;

      this.marker = this.markers[index];
      this.circle = this.circles[index];
      this.infowindow = this.infowindows[index];

      if (plot) {
        this.map.setCenter(this.marker.getPosition());
        // this.map.setZoom(14);
      } else {
        const center = this.map.getCenter();
        this.marker.setPosition(center);
        this.circle.setCenter(center);

        this.marker.setVisible(true);
        this.circle.setVisible(true);
      }

      this.infowindow.open(this.map, this.marker);
    },
    async viewTerminal(data, dataName, dataCode, dataCity, dataProvince) {
      const google = await gmapsInit();
      // Define the LatLng coordinates for the polygon's path.
      let plotPolygonCoords = [];
      data.forEach(coordinate => {
        plotPolygonCoords.push(coordinate);
      });

      // Construct the polygon.
      let thePolygon = new google.maps.Polygon({
        paths: plotPolygonCoords,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35
      });
      thePolygon.setMap(this.map);

      // Automatic puts marker in the center of the Polygon, don't remove
      let bounds = new google.maps.LatLngBounds();

      for (let i = 0; i < plotPolygonCoords.length; i++) {
        bounds.extend(plotPolygonCoords[i]);
      }

      let marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.BOUNCE
        // icon: iconBase
      });
      marker.setPosition(bounds.getCenter());
      this.map.setZoom(17);
      this.map.setCenter(bounds.getCenter());
      marker.addListener("click", toggleBounce);

      function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(function() {
            marker.setAnimation(null);
          }, 750);
        }
      }
      function capitalize(terminalName) {
        return terminalName.charAt(0).toUpperCase() + terminalName.slice(1);
      }

      let contentString = ` Name: ${dataName ? dataName.toUpperCase() : "-"}<br>
                            Code: ${dataCode}<br>
                            City: ${dataCity ? capitalize(dataCity) : "-"}<br>
                            Province: ${
                              dataProvince ? capitalize(dataProvince) : "-"
                            }`;
      let infowindow = new google.maps.InfoWindow({
        content: contentString
      });
      marker.addListener("click", function() {
        infowindow.open(this.map, marker);
      });
    },
    async plotTerminal(data) {
      const google = await gmapsInit();
      let map = this.map;

      // This is the Drawing Manager, this is very important, don't remove...
      let drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["polygon"]
        },
        polygonOptions: {
          fillOpacity: 0.35,
          strokeWeight: 5,
          clickable: false,
          editable: true,
          zIndex: 1
        }
      });
      drawingManager.setMap(this.map);

      // This is the addListener to get the coordinates of the polygon created, don't remove...
      let coordinates = [];
      google.maps.event.addListener(drawingManager, "polygoncomplete", function(
        polygon
      ) {
        let path = polygon.getPath();

        for (let i = 0; i < path.length; i++) {
          coordinates.push({
            lat: path.getAt(i).lat(),
            lng: path.getAt(i).lng()
          });
        }
        drawingManager.setDrawingMode(null);
      });
      this.polygonCoords = coordinates;
      this.terminalID = data;
    },
    async autoComplete() {
      const google = await gmapsInit();
      let pm = this;
      let input = document.getElementById("searchPlace");
      let autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.bindTo("bounds", pm.map);

      autocomplete.setFields([
        "address_components",
        "geometry",
        "icon",
        "name"
      ]);

      autocomplete.addListener("place_changed", function() {
        let place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          // window.alert("No details available for input: '" + place.name + "'");
          // return;
        }

        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
          //   map.fitBounds(place.geometry.viewport);
        }
        pm.map.setCenter(place.geometry.location);
        // }

        // pm.map.setZoom(14); // Why 17? Because it looks good.

        pm.marker.setPosition(place.geometry.location);

        pm.circle.setCenter(place.geometry.location);

        pm.$emit("currentCenter", {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        });

        pm.$emit("placeName", place.name);

        // console.log(this.lat);

        let address = "";
        if (place.address_components) {
          address = [
            (place.address_components[0] &&
              place.address_components[0].short_name) ||
              "",
            (place.address_components[1] &&
              place.address_components[1].short_name) ||
              "",
            (place.address_components[2] &&
              place.address_components[2].short_name) ||
              ""
          ].join(" ");
        }
      });
    },
    async previewPlottedMap(data) {
      const google = await gmapsInit();
      let plotPolygonCoords = [];
      data.forEach(coordinate => {
        plotPolygonCoords.push(coordinate);
      });

      // Construct the polygon.
      let thePolygon = new google.maps.Polygon({
        paths: plotPolygonCoords,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35
      });
      thePolygon.setMap(this.map);

      // Automatic puts marker in the center of the Polygon, don't remove
      let bounds = new google.maps.LatLngBounds();

      for (let i = 0; i < plotPolygonCoords.length; i++) {
        bounds.extend(plotPolygonCoords[i]);
      }
      // let iconBase = {
      //   url: "https://maps.google.com/mapfiles/kml/shapes/bus.png",
      //   scaledSize: new google.maps.Size(40, 40)
      // };

      let marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP
        // icon: iconBase
      });
      marker.setPosition(bounds.getCenter());
      this.map.setCenter(bounds.getCenter());
      marker.addListener("click", toggleBounce);

      function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(function() {
            marker.setAnimation(null);
          }, 750);
        }
      }
    },
    async addMarker(data) {
      const { lat, lng } = data;

      const google = await gmapsInit();
      let pm = this;

      let map = this.map;

      this.circle = new google.maps.Circle({
        strokeWeight: 0,
        fillColor: "#FFC0CB",
        fillOpacity: 0.35,
        map: map,
        center: {
          lat: lat,
          lng: lng
        },
        radius: 2000
      });

      this.marker = new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng
        },
        map: this.map,
        anchorPoint: new google.maps.Point(0, -29)
      });

      let marker = this.marker;
      let circle = this.circle;

      new google.maps.event.addListener(this.map, "drag", function() {
        const center = map.getCenter();

        marker.setPosition(center);
        circle.setCenter(center);

        pm.$emit("currentCenter", {
          lat: center.lat(),
          lng: center.lng()
        });

        // console.log(this.lat);
      });
    },
    changeCircleRadius(data) {
      if (this.circle) {
        this.circle.setRadius(data);
      }
    },
    async viewPlottedTerminals(data) {
      const google = await gmapsInit();
      // Define the LatLng coordinates for the polygon's path.
      let plotPolygonCoords = [];

      data.forEach(datum => {
        plotPolygonCoords.push(datum.coordinates);
      });

      // Construct the polygon.
      let thePolygon = new google.maps.Polygon({
        paths: plotPolygonCoords,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35
      });
      thePolygon.setMap(this.map);

      // Automatic puts marker in the center of the Polygon, don't remove

      data.forEach(datum => {
        let firstBounds = new google.maps.LatLngBounds();

        for (let i = 0; i < datum.coordinates.length; i++) {
          firstBounds.extend(datum.coordinates[i]);
        }

        let marker = new google.maps.Marker({
          map: this.map,
          animation: google.maps.Animation.BOUNCE
        });

        marker.setPosition(firstBounds.getCenter());

        marker.addListener("click", toggleBounce);

        function toggleBounce() {
          if (marker.getAnimation() !== null) {
            marker.setAnimation(null);
          } else {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function() {
              marker.setAnimation(null);
            }, 750);
          }
        }

        let contentString = ` Name: ${datum.name.toUpperCase()}<br>
                              Code: ${datum.code}<br>
                              City: ${datum.city.toUpperCase()}<br>
                              Province: ${datum.province.toUpperCase()}`;

        let infowindow = new google.maps.InfoWindow({
          content: contentString
        });

        marker.addListener("click", function() {
          infowindow.open(this.map, marker);
        });
      });

      let secondBounds = new google.maps.LatLngBounds();

      for (let i = 0; i < plotPolygonCoords.length; i++) {
        plotPolygonCoords[i].forEach(polygonCenters => {
          secondBounds.extend(polygonCenters);
        });
      }

      this.map.fitBounds(secondBounds);
    },
    clear() {
      this.map = null;
      this.index = null;
      this.marker = null;
      this.markers = [];
      this.circle = null;
      this.circles = [];
    }
  }
};
</script>


<style>
html,
body {
  margin: 0;
  padding: 0;
}

/* .App {
  width: 87.5vw;
  height: 80vh;
} */
</style>
